import classNames from 'classnames';
import { ComponentType, GetPageComponentViewModel } from '@/types/cml-api';
import { sendCtaClickEvent } from '@/features/analytics/datalayer/datalayer';
import { AppNextLink } from '@/features/app-next-link';
import { Webengage } from '@/features/webengage';
import { handleImageError } from '@/utils/image-error';
import { TimerTextColor } from './constants';
import CountdownTimer from './_components/countdown-timer';
import { IsLoadingLazyProps } from '../../type';
interface Props extends IsLoadingLazyProps {
  data: GetPageComponentViewModel;
  className?: string;
}
export function Countdown({
  data: {
    link,
    desktopImageUrl,
    mobileImageUrl,
    title,
    endTime,
    backgroundColor,
    id,
    sortKey
  },
  index,
  isLazy,
  className
}: Props) {
  const handleClick = (imageType: 'mobile' | 'desktop') => {
    sendCtaClickEvent({
      elementType: ComponentType.CountDown,
      elementIndex: index || 0,
      itemID: id || '',
      elementName: sortKey,
      destinationUrl: link || '',
      componentId: id ?? '',
      ImageUrl: imageType === 'mobile' ? mobileImageUrl : desktopImageUrl
    });
    Webengage.trackCtaAction({
      banner_type: ComponentType.CountDown,
      banner_name: sortKey ?? '',
      banner_index: index?.toString() || '0',
      url_destination: link || '',
      item_id: id || '',
      component_id: id || '',
      image_url: (imageType === 'mobile' ? mobileImageUrl : desktopImageUrl) ?? ''
    });
  };
  const countdownContent = <>
            <picture>
                {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
                <source media='(min-width: 576px)' srcSet={desktopImageUrl || ''} onClick={() => {
        handleClick('desktop');
      }} />
                <img src={mobileImageUrl} alt={title || ''} className='w-full' onError={handleImageError} onClick={() => {
        handleClick('mobile');
      }} loading={isLazy ? 'lazy' : undefined} />
            </picture>
            <CountdownTimer endTime={endTime || ''} textColor={backgroundColor || TimerTextColor} className='absolute bottom-4 left-1/2 -translate-x-1/2 sm:bottom-14 sm:left-12 sm:translate-x-0' />
        </>;
  return <div className={classNames('homepage-container', className)} data-sentry-component="Countdown" data-sentry-source-file="countdown.tsx">
            {link ? <AppNextLink href={link || ''} prefetch={false} className='relative block overflow-hidden rounded'>
                    {countdownContent}
                </AppNextLink> : <div className='relative overflow-hidden rounded'>{countdownContent}</div>}
        </div>;
}